//Personal Images
// import myImage from "./profile.png";
import myImage from "./ProfileImage.jpeg";

// Project Images
import musicPlayer from "./projects/music-player.png";
import ticTacToe from "./projects/ticTacToe.jpg";
import toDo from "./projects/to-do.png";
import qrGenerator from "./projects/qr-generator.png";
import portfolio from "./projects/portfolio-white.png";
import travelAgency from "./projects/travelAgency.png";
import athawdabazaar from "./projects/athawdabazaar.png";
import bookify from "./projects/bookify.png";
import littleSpace from "./projects/littleSpace.jpeg";
import V_secretum from "./projects/V_secretum.jpeg";

// Language Images
import javascript from "./langImages/javascript.svg";
import java from "./langImages/java.svg";
import python from "./langImages/python.svg";
import bash from "./langImages/bash.svg";
import markdown from "./langImages/markdown.svg";
import typescript from "./langImages/typescript.svg";
import html from "./langImages/html.svg";
import css from "./langImages/css.svg";
import golang from "./langImages/golang.svg";

// Framework / Libraries Images
import react from "./frameLibImages/react.svg";
import next from "./frameLibImages/next.svg";
import tailwindcss from "./frameLibImages/tailwindcss.svg";
import bootstrap from "./frameLibImages/bootstrap.svg";
import dotnet from "./frameLibImages/dotnet.svg";

// Database Images
import mysql from "./databaseImages/mysql.svg";
import firebase from "./databaseImages/firebase.svg";
import mongodb from "./databaseImages/mongodb.svg";

// Backend Images
import nodejs from "./backendImages/nodejs.svg";
import expressjs from "./backendImages/express.svg";

// Tools
import npm from "./tools/npm.svg";
import docker from "./tools/docker.svg";
import git from "./tools/git.svg";
import github from "./tools/github.svg";
import vscode from "./tools/vscode.svg";
import ubuntu from "./tools/ubuntu.svg";
import vercel from "./tools/vercel.svg";

// Event Images
import BreachForceSep from "./eventImages/BreachForceSep.jpeg";
import BrowserStack from "./eventImages/BrowserStack.jpeg";
import CNCFThaneAug from "./eventImages/CNCFThaneAug.jpeg";
import CNCFThaneSep from "./eventImages/CNCFThaneSep.jpeg";
import middleware from "./eventImages/middleware.jpg";
import MongoDB from "./eventImages/MongoDB.jpeg";
import CNCFThaneJune from "./eventImages/CNCF_Thane_June-2025.jpg";
import TatvaHackathon from "./eventImages/TatvaHackathon.jpeg";
import TechVistaHackathon from "./eventImages/TechVistaHackathon.jpeg";

export const profile = myImage;

export const projectImages = {
  musicPlayer: musicPlayer,
  ticTacToe: ticTacToe,
  toDo: toDo,
  qrGenerator: qrGenerator,
  travelAgency: travelAgency,
  portfolio: portfolio,
  athawdabazaar: athawdabazaar,
  bookify: bookify,
  littleSpace: littleSpace,
  V_secretum: V_secretum,
};

export const languageImages = {
  javascript: javascript,
  java: java,
  python: python,
  markdown: markdown,
  typescript: typescript,
  bash: bash,
  html: html,
  css: css,
  golang: golang,
};

export const frameworkLibrariesImages = {
  react: react,
  next: next,
  bootstrap: bootstrap,
  tailwindcss: tailwindcss,
  dotnet: dotnet,
};

export const databaseImages = {
  mysql: mysql,
  mongodb: mongodb,
  firebase: firebase,
};

export const backendImages = {
  nodejs: nodejs,
  next: next,
  expressjs: expressjs,
};

export const toolsImages = {
  npm: npm,
  docker: docker,
  git: git,
  github: github,
  vscode: vscode,
  ubuntu: ubuntu,
  vercel: vercel,
};

export const eventImages = {
  BreachForceSep: BreachForceSep,
  BrowserStack: BrowserStack,
  CNCFThaneAug: CNCFThaneAug,
  CNCFThaneSep: CNCFThaneSep,
  middleware: middleware,
  MongoDB: MongoDB,
  CNCFThaneJune: CNCFThaneJune,
  TatvaHackathon: TatvaHackathon,
  TechVistaHackathon: TechVistaHackathon,
};
